export default [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/Login.vue'),
    meta: { title: '登录', requiresAuth: false, noindex: true }
  },
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: '/admin/dashboard',
    meta: { requiresAuth: true, noindex: true },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: { title: '仪表盘', section: 'ADMIN', menuIndex: '01' }
      },
      {
        path: 'articles',
        name: 'AdminArticles',
        component: () => import('@/views/admin/ArticleList.vue'),
        meta: { title: '文章管理', section: 'CONTENT', menuIndex: '02' }
      },
      {
        path: 'articles/create',
        name: 'AdminArticleCreate',
        component: () => import('@/views/admin/ArticleEdit.vue'),
        meta: { title: '新建文章', section: 'CONTENT', menuIndex: '02' }
      },
      {
        path: 'articles/edit/:id',
        name: 'AdminArticleEdit',
        component: () => import('@/views/admin/ArticleEdit.vue'),
        meta: { title: '编辑文章', section: 'CONTENT', menuIndex: '02' }
      },
      {
        path: 'notes',
        name: 'AdminNotes',
        component: () => import('@/views/admin/NoteList.vue'),
        meta: { title: '简言管理', section: 'CONTENT', menuIndex: '03' }
      },
      {
        path: 'categories',
        name: 'AdminCategories',
        component: () => import('@/views/admin/CategoryList.vue'),
        meta: { title: '分类管理', section: 'CONTENT', menuIndex: '04' }
      },
      {
        path: 'comments',
        name: 'AdminComments',
        component: () => import('@/views/admin/CommentList.vue'),
        meta: { title: '评论管理', section: 'CONTENT', menuIndex: '05' }
      },
      {
        path: 'links',
        name: 'AdminLinks',
        component: () => import('@/views/admin/LinkList.vue'),
        meta: { title: '友链管理', section: 'CONTENT', menuIndex: '06' }
      },
      {
        path: 'dicts',
        name: 'AdminDicts',
        component: () => import('@/views/admin/Dict.vue'),
        meta: { title: '字典管理', section: 'CONFIG', menuIndex: '07' }
      },
      {
        path: 'models',
        name: 'AdminModels',
        component: () => import('@/views/admin/Model.vue'),
        meta: { title: '模型配置', section: 'CONFIG', menuIndex: '08' }
      },
      {
        path: 'settings',
        name: 'AdminSettings',
        component: () => import('@/views/admin/Settings.vue'),
        meta: { title: '系统设置', section: 'CONFIG', menuIndex: '09' }
      },
      {
        path: 'files',
        name: 'AdminFiles',
        component: () => import('@/views/admin/FileRecordList.vue'),
        meta: { title: '文件记录', section: 'MAINTENANCE', menuIndex: '10' }
      },
      {
        path: 'email-logs',
        name: 'AdminEmailLogs',
        component: () => import('@/views/admin/EmailLogList.vue'),
        meta: { title: '邮件日志', section: 'MAINTENANCE', menuIndex: '11' }
      },
      {
        path: 'ai-logs',
        name: 'AdminAiLogs',
        component: () => import('@/views/admin/AiLogList.vue'),
        meta: { title: 'AI 调用日志', section: 'MAINTENANCE', menuIndex: '12' }
      },
      {
        path: 'recycle-bin',
        name: 'AdminRecycleBin',
        component: () => import('@/views/admin/RecycleBin.vue'),
        meta: { title: '回收站', section: 'MAINTENANCE', menuIndex: '13' }
      }
    ]
  }
]
